





import {
  defineComponent,
} from '@vue/composition-api';

import PageColumnWithSupplierEditor from '@/components/Supplier/PageColumnWithSupplierEditor.vue';

const Edit = defineComponent({
  // setup() {},
  components: {
    PageColumnWithSupplierEditor,
  },
});

export default Edit;
